import { plural } from '@cian/utils';

import { getNewbuildingFeaturePromoLabels } from './getNewbuildingFeaturePromoLabels';
import { ELabelColor, ILabel } from '../../../types/label';
import { ENewbuildingSnippetType, IOffer } from '../../../types/offer';
import { IOfferReduxApi } from 'fragments/OfferCardWidget/shared/types/offer-card';
import { IJsonQuery } from 'shared/json_query';
import { isNewobjectPage } from 'shared/utils/isNewobjectPage';

export function getNewbuildingSnippetLabels({
  labelsV1,
  labelsV2,
  api,
  offer,
  position,
  jsonQuery,
}: {
  labelsV1: ILabel[];
  labelsV2: ILabel[];
  api: IOfferReduxApi;
  offer: IOffer;
  position: number;
  jsonQuery: IJsonQuery;
}): ILabel[] {
  const cplLabels: ILabel[] = [];

  if (labelsV2) {
    cplLabels.push(...labelsV2);
  }

  const snippetType = offer.newbuilding?.snippetType;
  const countPromos = offer.newbuilding?.countPromos;
  const isUnique = offer.isUnique;
  const isNewbuildingBrokerBookingEnabled = offer.newbuildingBroker?.bookingEnabled;
  const promoLabels = getNewbuildingFeaturePromoLabels(offer);

  if (promoLabels && snippetType !== ENewbuildingSnippetType.Basic) {
    cplLabels.push(
      ...promoLabels.map(label => ({
        ...label,
        color: snippetType === ENewbuildingSnippetType.Maximum ? ELabelColor.DarkGreen : ELabelColor.Green,
      })),
    );
  }

  if (countPromos && snippetType !== ENewbuildingSnippetType.Basic) {
    const moreText = promoLabels && snippetType === ENewbuildingSnippetType.Maximum ? 'ещё ' : '';

    cplLabels.push({
      color: snippetType === ENewbuildingSnippetType.Maximum ? ELabelColor.DarkGreen : ELabelColor.Green,
      text: `${moreText}${countPromos} ${plural(countPromos, ['акция', 'акции', 'акций'])}`,
    });
  }

  const decorLabel = labelsV1.find(label => label.text === 'С отделкой');
  const salesLeaderLabel = labelsV1.find(label => label.text === 'ЖК лидер продаж');

  if (decorLabel) {
    cplLabels.push(decorLabel);
  } else if (isUnique) {
    cplLabels.push({ color: ELabelColor.Blue, text: 'Только на Циан' });
  } else if (salesLeaderLabel) {
    cplLabels.push(salesLeaderLabel);
  }

  if (isNewbuildingBrokerBookingEnabled) {
    if (isNewobjectPage(jsonQuery)) {
      cplLabels.push({
        color: ELabelColor.SimpleBlue,
        text: 'Онлайн-бронирование',
      });
    } else {
      cplLabels.push({
        color: ELabelColor.SimpleBlueIconed,
        text: 'Онлайн-бронирование',
        onClick: () => api.openNewbuildingBrokerCallbackPopup(offer, position),
      });
    }
  }

  return cplLabels;
}
